import { useId } from 'react'
import { cn } from '@/lib/utils'

interface Props {
  size?: number
  className?: string
  /** Render flat in the current text colour instead of the RezzAI gradient. */
  mono?: boolean
}

// RezzAI's mark — a chef's hat in the product gradient (blue → violet → pink → amber).
// Used anywhere an AI-powered action is offered so the capability reads as one feature.
export function RezzAiIcon({ size = 16, className, mono = false }: Props) {
  const gradientId = useId()
  const fill = mono ? 'currentColor' : `url(#${gradientId})`

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn('shrink-0', className)}
      aria-hidden="true"
    >
      {!mono && (
        <defs>
          <linearGradient id={gradientId} x1="2" y1="21" x2="21" y2="3" gradientUnits="userSpaceOnUse">
            <stop offset="0%"   stopColor="#3B82F6" />
            <stop offset="40%"  stopColor="#8B5CF6" />
            <stop offset="72%"  stopColor="#EC4899" />
            <stop offset="100%" stopColor="#FBBF24" />
          </linearGradient>
        </defs>
      )}

      {/* Puffed crown */}
      <path
        d="M12 3.1c-1.14-1.32-3.06-1.6-4.5-.58-1.26.9-1.75 2.52-1.3 3.86C4.55 6.6 3.3 8.02 3.3 9.73c0 1.63 1.13 3.03 2.66 3.42v1.62h12.08v-1.62c1.53-.39 2.66-1.79 2.66-3.42 0-1.71-1.25-3.13-2.9-3.35.45-1.34-.04-2.96-1.3-3.86-1.44-1.02-3.36-.74-4.5.58Z"
        fill={fill}
      />
      {/* Band */}
      <path
        d="M5.96 16.27h12.08v3.13c0 .88-.71 1.6-1.6 1.6H7.56c-.89 0-1.6-.72-1.6-1.6v-3.13Z"
        fill={fill}
        opacity={0.82}
      />
      {/* Pleats */}
      <g stroke="#fff" strokeWidth="0.9" strokeLinecap="round" opacity="0.55">
        <path d="M9.4 8.6v4.6" />
        <path d="M12 8.2v5" />
        <path d="M14.6 8.6v4.6" />
      </g>
    </svg>
  )
}
